<div class="promo-filters-container">
  <!-- The spinner is now at the root level to cover the entire container -->
  <!-- <div class="spinner-container" *ngIf="isLoading">
    <mat-spinner diameter="50"></mat-spinner>
  </div> -->

  <header class="promo-filters-header">
    <span class="promo-title">Filter Scenarios</span>
    <button mat-icon-button class="close-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="filter-fields">
    <!-- Dynamic multi-select filters -->
    <ng-container *ngFor="let filter of filters; trackBy: trackByFilterKey">
      <app-multiple-check-box-filter
        [displayName]="filter.label"
        [options]="filter.options"
        [isDisabled]="!filter.enabled"
        (selectionChanged)="onFilterApplied($event, filter.key)"
      ></app-multiple-check-box-filter>
    </ng-container>

    <!-- UPDATED: Period Filter Section -->
    <div class="period-filter-group">
      <span class="period-label">Period :</span>
      <div class="period-dropdowns-container">
        <mat-form-field appearance="outline" class="period-select">
          <mat-label>Start {{ periodLabel }}</mat-label>
          <mat-select
            [(ngModel)]="startPeriod"
            (selectionChange)="onStartPeriodChange()"
          >
            <mat-option
              *ngFor="let option of allPeriodOptions"
              [value]="option.value"
            >
              {{ option.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="period-select">
          <mat-label>End {{ periodLabel }}</mat-label>
          <mat-select [(ngModel)]="endPeriod" [disabled]="!startPeriod">
            <mat-option
              *ngFor="let option of endPeriodOptions"
              [value]="option.value"
            >
              {{ option.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Static Discount Input Field -->
    <div class="discount-field-container">
      <mat-form-field class="discount-input" appearance="outline">
        <mat-label>Discount</mat-label>
        <input
          matInput
          type="number"
          placeholder="Enter discount"
          [(ngModel)]="discountValue"
        />
      </mat-form-field>
    </div>
  </div>

  <footer class="button-actions">
    <button class="reset-button" (click)="onReset()">Reset</button>
    <button
      class="apply-button"
      (click)="onApply()"
      [disabled]="discountValue === null || discountValue === undefined"
      matTooltip="Enter a valid discount to apply filters"
      [matTooltipDisabled]="
        discountValue !== null && discountValue !== undefined
      "
    >
      Apply Filters
    </button>
  </footer>
</div>
